import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Icon, SpinnerLoader, Tooltip } from 'shared/ui'
import { useSendFromContext } from 'widgets/SendFrom/context/context'
import { SendFromTriggerInnerContent } from 'widgets/SendFrom/ui/SendFromTriggerInnerContent/SendFromTriggerInnerContent'
import styles from './styles.module.scss'

export type INumbersInboxesPickerButtonProps = {
  active?: boolean
}

export const ButtonTrigger: FC<INumbersInboxesPickerButtonProps> = observer(({ active }) => {
  const { loading, error, selectedDropdownItem } = useSendFromContext()

  return (
    <Tooltip label={error} placement={'right'} color={'red'} disableInteractive>
      <div
        className={classNames(styles.button, {
          [styles.active]: active,
          [styles.button__error]: error,
        })}
      >
        {loading && (
          <SpinnerLoader
            ariaLabel={'ButtonTrigger'}
            size={14}
            determinatecolor={'var(--gray-70)'}
            indeterminatecolor={'var(--gray-30)'}
          />
        )}
        {!loading && <SendFromTriggerInnerContent item={selectedDropdownItem} />}
        {!loading && !error && (
          <Icon icon={active ? 'chevronUp' : 'chevronDown'} className={styles.chevron} tertiary />
        )}
        {error && <Icon className={styles.button__iconError} icon={'alertTriangle'} />}
      </div>
    </Tooltip>
  )
})
